import React, {FC, useEffect, useState} from "react";
import {Button, Form, Input, Modal, notification} from "antd";
import {changeDocument} from "../../manage-reestr-list/actions";

const ManageReestrEditItemModal: FC = (props: any) => {
    const [isSaving, setSaving] = useState(false);
    const {selectedDoc} = props;

    const [form] = Form.useForm();

    const handleOk = () => {
        form.validateFields().then(
            () => {
                if (selectedDoc) {
                    setSaving(true);

                    const {name} = form.getFieldsValue();

                    changeDocument(
                        {
                            nameEn: name,
                            nameKk: name,
                            nameQq: name,
                            nameRu: name
                        },
                        selectedDoc.id
                    )
                        .then(
                            () => {
                                notification['success']({
                                    message: 'Файл добавлен обновлен!'
                                });
                                props.handleOk();
                                form.resetFields();
                            }
                        )
                        .finally(() => setSaving(false));
                }
            }
        );
    };

    const handleCancel = () => {
        props.handleCancel();
        form.resetFields();
    };

    useEffect(() => {
        if (selectedDoc) {
            const {nameEn, nameRu, nameQq, nameKk} = selectedDoc.localizedName;

            if (nameEn) {
                form.setFieldValue('name', nameEn)
            } else if (nameKk) {
                form.setFieldValue('name', nameKk)
            } else if (nameRu) {
                form.setFieldValue('name', nameRu)
            } else if (nameQq) {
                form.setFieldValue('name', nameQq)
            }
        }
    }, [selectedDoc]);



    return (
        <Modal title="Редактирование файла"
               open={props.isModalOpen}
               onOk={handleOk}
               onCancel={handleCancel}
               footer={[
                   <Button type="admin" key="back" onClick={handleCancel}>
                       Отмена
                   </Button>,
                   <Button key="submit" type="primary admin" onClick={handleOk} loading={isSaving}>
                       Сохранить
                   </Button>
               ]}
        >
            <div>
                <Form layout="vertical" form={form}>
                    <Form.Item
                        label="Название"
                        name="name"
                        rules={[{ required: true, message: 'Это поле обязательно для заполнения!' }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    )
};

export default ManageReestrEditItemModal;
